import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { TextField } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import { StyledDiv } from 'containers/ExpertExpertise/Dialogs/styles';
import DialogMission from 'containers/ExpertExpertise/Dialogs/index';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerFeeNote/messages';
import { get } from 'lodash';
import { FeeNote } from 'containers/LawyerFeeNote/typings';
import { STATUS_PENDING } from 'containers/LawyerFeeNote/constants';

export interface FeeNoteUpdateAmountDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  validateDialog: Function;
  feeNote: FeeNote;
  viewByClaim: boolean;
  pageSize: any;
  claimNumber: string;
  page: any;
  requestFeeNotes: Function;
}

const FeeNoteUpdateAmountDialog: React.FC<FeeNoteUpdateAmountDialogProps> = (
  props,
): JSX.Element => {
  const [newFeeNoteAmount, setNewFeeNoteAmount] = useState('');

  const { onClose, open } = props;

  /* istanbul ignore next */
  const handleChangeFeeNoteAmount = (event: any) => {
    setNewFeeNoteAmount(event.target.value);
  };

  /* istanbul ignore next */
  const successCallBack = () => {
    toast.success(translate(messages.successDialogUpdateAmount, props));
    props.onClose();
    if (props.viewByClaim) {
      props.requestFeeNotes(props.claimNumber);
    } else {
      props.requestFeeNotes(STATUS_PENDING, props.page, props.pageSize);
    }
  };

  /* istanbul ignore next */
  const onSubmit = () => {
    props.validateDialog(
      {
        id: get(props.feeNote, 'id'),
        amountTtc: newFeeNoteAmount,
        amountHt: Math.round((newFeeNoteAmount as any) / 1.2),
      },
      successCallBack,
    );
  };

  return (
    <DialogMission
      open={open}
      onClose={onClose}
      validateDialog={onSubmit}
      title={translate({ ...messages.newAmount }, props)}
      content={
        <StyledDiv>
          <TextField
            onChange={handleChangeFeeNoteAmount}
            name={'newFeeNoteAmount'}
            value={newFeeNoteAmount}
            label={translate({ ...messages.newAmount }, props)}
            className="input"
            type="number"
            fullWidth
          />
        </StyledDiv>
      }
      disabled={!newFeeNoteAmount}
    />
  );
};

FeeNoteUpdateAmountDialog.defaultProps = {
  open: false,
};

export default injectIntl(FeeNoteUpdateAmountDialog);
